// Mock data for Payment Gateway Module
// This will be replaced with actual API calls in Backend Phase

// Mock Payment Gateways (Super Admin view)
export const mockGateways = [
  {
    id: 'gateway-001',
    gatewayName: 'Stripe',
    gatewayType: 'CARD',
    displayName: 'Credit Card via Stripe',
    currentMode: 'DEVELOPMENT',
    isActive: true,
    feePercentage: 2.9,
    feeFixed: 1.00,
    currency: 'AED',
    supportedCurrencies: ['AED', 'USD', 'EUR', 'GBP'],
    devCredentials: {
      publicKey: 'pk_test_XXXXXXXXXXXXXXXX',
      secretKey: '••••••••••••••••',
      webhookSecret: '••••••••••••••••',
    },
    prodCredentials: {
      publicKey: '',
      secretKey: '',
      webhookSecret: '',
    },
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-02-20T14:30:00Z',
  },
  {
    id: 'gateway-002',
    gatewayName: 'Tabby',
    gatewayType: 'BNPL',
    displayName: 'Buy Now Pay Later (Tabby)',
    currentMode: 'DEVELOPMENT',
    isActive: true,
    feePercentage: 3.0,
    feeFixed: 0,
    currency: 'AED',
    supportedCurrencies: ['AED', 'SAR', 'KWD', 'BHD'],
    devCredentials: {
      merchantCode: 'THAKLIS_TEST',
      publicKey: 'pk_test_YYYYYYYYYYYYYYYY',
      secretKey: '••••••••••••••••',
    },
    prodCredentials: {
      merchantCode: '',
      publicKey: '',
      secretKey: '',
    },
    createdAt: '2024-01-20T11:00:00Z',
    updatedAt: '2024-02-18T16:45:00Z',
  },
  {
    id: 'gateway-003',
    gatewayName: 'Noqodi',
    gatewayType: 'WALLET',
    displayName: 'Noqodi Digital Wallet',
    currentMode: 'DEVELOPMENT',
    isActive: false,
    feePercentage: 1.5,
    feeFixed: 0,
    currency: 'AED',
    supportedCurrencies: ['AED'],
    devCredentials: {
      merchantId: 'NOQODI_TEST_12345',
      apiKey: '••••••••••••••••',
      webhookUrl: 'https://dev.thaklis.com/api/webhook/noqodi',
    },
    prodCredentials: {
      merchantId: '',
      apiKey: '',
      webhookUrl: '',
    },
    createdAt: '2024-02-01T09:00:00Z',
    updatedAt: '2024-02-10T12:00:00Z',
  },
  {
    id: 'gateway-004',
    gatewayName: 'Network International',
    gatewayType: 'CARD',
    displayName: 'Credit Card via Network International',
    currentMode: 'DEVELOPMENT',
    isActive: true,
    feePercentage: 2.75,
    feeFixed: 0.50,
    currency: 'AED',
    supportedCurrencies: ['AED', 'USD', 'EUR', 'SAR'],
    devCredentials: {
      merchantId: 'NI_TEST_MERCHANT',
      apiKey: 'pk_test_ZZZZZZZZZZZZZZZZ',
      secretKey: '••••••••••••••••',
      terminalId: 'TERM_001',
    },
    prodCredentials: {
      merchantId: '',
      apiKey: '',
      secretKey: '',
      terminalId: '',
    },
    createdAt: '2024-02-05T08:00:00Z',
    updatedAt: '2024-02-15T10:20:00Z',
  },
];

// Mock Customer Payment Configurations
export const mockCustomerConfigs = [
  {
    id: 'config-001',
    organizationId: 'org-001',
    organizationName: 'Acme Corporation',
    gatewayId: 'gateway-001',
    gatewayName: 'Stripe',
    isEnabled: true,
    enabledAt: '2024-02-01T10:00:00Z',
    enabledBy: 'Super Admin',
  },
  {
    id: 'config-002',
    organizationId: 'org-001',
    organizationName: 'Acme Corporation',
    gatewayId: 'gateway-002',
    gatewayName: 'Tabby',
    isEnabled: true,
    enabledAt: '2024-02-01T10:05:00Z',
    enabledBy: 'Super Admin',
  },
  {
    id: 'config-003',
    organizationId: 'org-002',
    organizationName: 'Tech Solutions LLC',
    gatewayId: 'gateway-001',
    gatewayName: 'Stripe',
    isEnabled: true,
    enabledAt: '2024-02-05T14:00:00Z',
    enabledBy: 'Super Admin',
  },
  {
    id: 'config-004',
    organizationId: 'org-002',
    organizationName: 'Tech Solutions LLC',
    gatewayId: 'gateway-003',
    gatewayName: 'Noqodi',
    isEnabled: false,
    enabledAt: null,
    enabledBy: null,
  },
];

// Mock Organizations (for dropdown in customer config)
export const mockOrganizations = [
  { id: 'org-001', name: 'Acme Corporation' },
  { id: 'org-002', name: 'Tech Solutions LLC' },
  { id: 'org-003', name: 'Global Enterprises' },
  { id: 'org-004', name: 'Innovation Hub' },
  { id: 'org-005', name: 'Digital Services Co' },
];

// Mock Topup Requests (Customer User view)
export const mockTopupRequests = [
  {
    id: 'topup-001',
    requestedAt: '2024-03-15T10:30:00Z',
    requestedBy: 'John Doe',
    requestedByEmail: 'john@acme.com',
    amount: 5000.00,
    currency: 'AED',
    status: 'COMPLETED',
    paymentMethod: 'GATEWAY',
    gatewayName: 'Stripe',
    gatewayType: 'CARD',
    transactionId: 'ch_3OqXXXXXXXXXXXXX',
    gatewayFee: 146.00,
    netAmount: 4854.00,
    processedAt: '2024-03-15T10:30:45Z',
    walletBalanceBefore: 12000.00,
    walletBalanceAfter: 17000.00,
  },
  {
    id: 'topup-002',
    requestedAt: '2024-03-14T14:20:00Z',
    requestedBy: 'Jane Smith',
    requestedByEmail: 'jane@acme.com',
    amount: 3000.00,
    currency: 'AED',
    status: 'COMPLETED',
    paymentMethod: 'BANK_TRANSFER',
    gatewayName: null,
    gatewayType: null,
    bankName: 'Emirates NBD',
    referenceNumber: 'REF123456789',
    bankAccountName: 'Thaklis - ENBD Main Account',
    depositSlip: 'deposit_slip_001.pdf',
    approvedBy: 'Finance Admin',
    approvedAt: '2024-03-14T15:00:00Z',
    gatewayFee: 0,
    netAmount: 3000.00,
    processedAt: '2024-03-14T15:00:00Z',
    walletBalanceBefore: 9000.00,
    walletBalanceAfter: 12000.00,
  },
  {
    id: 'topup-003',
    requestedAt: '2024-03-16T09:15:00Z',
    requestedBy: 'Ahmed Ali',
    requestedByEmail: 'ahmed@techsolutions.com',
    amount: 2000.00,
    currency: 'AED',
    status: 'PENDING_APPROVAL',
    paymentMethod: 'BANK_TRANSFER',
    gatewayName: null,
    gatewayType: null,
    bankName: 'ADCB',
    referenceNumber: 'REF987654321',
    bankAccountName: 'Thaklis - ADCB Business Account',
    depositSlip: 'deposit_slip_002.pdf',
    approvedBy: null,
    approvedAt: null,
    gatewayFee: 0,
    netAmount: 2000.00,
    processedAt: null,
  },
  {
    id: 'topup-004',
    requestedAt: '2024-03-13T11:00:00Z',
    requestedBy: 'Sara Mohammed',
    requestedByEmail: 'sara@acme.com',
    amount: 1500.00,
    currency: 'AED',
    status: 'COMPLETED',
    paymentMethod: 'GATEWAY',
    gatewayName: 'Tabby',
    gatewayType: 'BNPL',
    transactionId: 'tabby_ZZZ123456',
    gatewayFee: 45.00,
    netAmount: 1455.00,
    processedAt: '2024-03-13T11:01:30Z',
    walletBalanceBefore: 7500.00,
    walletBalanceAfter: 9000.00,
  },
  {
    id: 'topup-005',
    requestedAt: '2024-03-16T16:45:00Z',
    requestedBy: 'John Doe',
    requestedByEmail: 'john@acme.com',
    amount: 10000.00,
    currency: 'AED',
    status: 'FAILED',
    paymentMethod: 'GATEWAY',
    gatewayName: 'Stripe',
    gatewayType: 'CARD',
    transactionId: null,
    gatewayFee: 0,
    netAmount: 0,
    processedAt: null,
    errorMessage: 'Insufficient funds in card',
    failedAt: '2024-03-16T16:45:15Z',
  },
];

// Mock Gateway Cost Analysis (Super Admin Dashboard)
export const mockCostAnalysis = [
  {
    gatewayName: 'Stripe',
    totalTransactions: 145,
    totalVolume: 725000.00,
    totalFees: 21145.00,
    avgFeePercentage: 2.92,
    lastMonthVolume: 680000.00,
    lastMonthFees: 19840.00,
    trend: 'up',
  },
  {
    gatewayName: 'Tabby',
    totalTransactions: 87,
    totalVolume: 435000.00,
    totalFees: 13050.00,
    avgFeePercentage: 3.0,
    lastMonthVolume: 390000.00,
    lastMonthFees: 11700.00,
    trend: 'up',
  },
  {
    gatewayName: 'Noqodi',
    totalTransactions: 12,
    totalVolume: 60000.00,
    totalFees: 900.00,
    avgFeePercentage: 1.5,
    lastMonthVolume: 45000.00,
    lastMonthFees: 675.00,
    trend: 'up',
  },
  {
    gatewayName: 'Network International',
    totalTransactions: 68,
    totalVolume: 340000.00,
    totalFees: 9690.00,
    avgFeePercentage: 2.85,
    lastMonthVolume: 310000.00,
    lastMonthFees: 8835.00,
    trend: 'up',
  },
  {
    gatewayName: 'Bank Transfer',
    totalTransactions: 34,
    totalVolume: 340000.00,
    totalFees: 0,
    avgFeePercentage: 0,
    lastMonthVolume: 280000.00,
    lastMonthFees: 0,
    trend: 'up',
  },
];

// Mock Bank Accounts (Thaklis physical bank accounts - for Week 3-4)
export const mockBankAccounts = [
  {
    id: 'bank-001',
    accountName: 'Thaklis - ENBD Main Account',
    bankName: 'Emirates NBD',
    accountNumber: '****7890',
    iban: 'AE07 0331 2345 6789 0123 456',
    currency: 'AED',
    currentBalance: 1250000.00,
    isActive: true,
    type: 'OPERATIONS',
    swiftCode: 'EBILAEAD',
    branchName: 'Dubai Main Branch',
  },
  {
    id: 'bank-002',
    accountName: 'Thaklis - ADCB Business Account',
    bankName: 'Abu Dhabi Commercial Bank',
    accountNumber: '****3456',
    iban: 'AE33 0321 9876 5432 1098 765',
    currency: 'AED',
    currentBalance: 780000.00,
    isActive: true,
    type: 'OPERATIONS',
    swiftCode: 'ADCBAEAA',
    branchName: 'Abu Dhabi Business Center',
  },
  {
    id: 'bank-003',
    accountName: 'Thaklis - FAB USD Account',
    bankName: 'First Abu Dhabi Bank',
    accountNumber: '****6789',
    iban: 'AE89 0351 0123 4567 8901 234',
    currency: 'USD',
    currentBalance: 125000.00,
    isActive: true,
    type: 'REGIONAL',
    swiftCode: 'NBADAEAA',
    branchName: 'Abu Dhabi International',
  },
  {
    id: 'bank-004',
    accountName: 'Thaklis - DIB Shariah Account',
    bankName: 'Dubai Islamic Bank',
    accountNumber: '****2345',
    iban: 'AE44 0401 2345 6789 0123 456',
    currency: 'AED',
    currentBalance: 450000.00,
    isActive: true,
    type: 'OPERATIONS',
    swiftCode: 'DUIBAEAD',
    branchName: 'Dubai Islamic Center',
  },
  {
    id: 'bank-005',
    accountName: 'Thaklis - Mashreq Reserve Account',
    bankName: 'Mashreq Bank',
    accountNumber: '****8901',
    iban: 'AE56 0331 5678 9012 3456 789',
    currency: 'AED',
    currentBalance: 890000.00,
    isActive: true,
    type: 'REGIONAL',
    swiftCode: 'BOMLAEAD',
    branchName: 'Dubai Marina Branch',
  },
  {
    id: 'bank-006',
    accountName: 'Thaklis - RAK Bank Secondary',
    bankName: 'RAK Bank',
    accountNumber: '****4567',
    iban: 'AE67 0401 6789 0123 4567 890',
    currency: 'AED',
    currentBalance: 320000.00,
    isActive: false,
    type: 'OPERATIONS',
    swiftCode: 'NRAKAEAK',
    branchName: 'Ras Al Khaimah Main',
  },
];

// Gateway types and their display info
export const gatewayTypes = [
  { value: 'CARD', label: 'Credit/Debit Card', icon: 'CreditCard' },
  { value: 'BNPL', label: 'Buy Now Pay Later', icon: 'Schedule' },
  { value: 'WALLET', label: 'Digital Wallet', icon: 'AccountBalanceWallet' },
  { value: 'BANK', label: 'Bank Transfer', icon: 'AccountBalance' },
];

// Topup status types
export const topupStatuses = [
  { value: 'PENDING_APPROVAL', label: 'Pending Approval', color: 'warning' },
  { value: 'COMPLETED', label: 'Completed', color: 'success' },
  { value: 'FAILED', label: 'Failed', color: 'error' },
  { value: 'CANCELLED', label: 'Cancelled', color: 'default' },
];

// Helper function to get cheapest gateway for an amount
export const getCheapestGateway = (amount, activeGateways = mockGateways.filter(g => g.isActive)) => {
  const costs = activeGateways.map(gateway => ({
    gatewayId: gateway.id,
    gatewayName: gateway.gatewayName,
    fee: (amount * gateway.feePercentage / 100) + gateway.feeFixed,
    feePercentage: gateway.feePercentage,
    feeFixed: gateway.feeFixed,
  }));

  costs.sort((a, b) => a.fee - b.fee);
  return costs[0];
};
